import { AuthInternalServerError } from "@features/auth/core/domain/login/models/version-2/auth-error-version2.model";
import { SpamResendCodeError, VerifyOtpCodeExpiredError, VerifyOtpCodeNotMatchError } from "@features/auth/core/domain/account-first-login/models/verify-otp-code.error";

export const VERIFY_OTP_ERROR_CODE = {
  VerifyOtpCodeNotMatchError: VerifyOtpCodeNotMatchError._code,
  VerifyOtpCodeExpiredError: VerifyOtpCodeExpiredError._code,
  SpamResendCodeError: SpamResendCodeError._code,
  AuthInternalServerError: AuthInternalServerError._code,
}
